import React, { Component } from 'react'
import { ListGroup, ListGroupItem } from 'reactstrap'
import { connect } from 'react-redux'
import { formatNumber } from '../../Utils'
import { withTranslation } from 'react-i18next';

import * as actions from '../../store/actions'

class AdditionalItem extends Component {
    render() {
        const {
            decoration,
            decorationSelected,
            decorationPrice,
            plated,
            platedSelected,
            platedPrice,
            ruffles,
            sequinedSelected,
            rufflesPrice,
            rufflesSelected,
            long,
            longSelected,
            longPrice,
            impregnate,
            impregnateSelected,
            impregnatePrice,
            chiffon,
            chiffonSelected,
            chiffonPrice,
            bib,
            bibSelected,
            bibPrice,
            OnAdditionalCheck,
            itemIndex,
            t
        } = this.props

        return (
            <ListGroup flush className="shopping-item-section">
                <ListGroupItem className="item-main-header">
                    <strong>{t('cart.sections.surcharge')}</strong>
                </ListGroupItem>
                {
                    long &&
                    <ListGroupItem className="item-button" active={longSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "longSelected")}>
                        <div className="d-flex">
                            <div className="item-header">{t('cart.options.withLong')}</div>
                            <div className="small-price">
                                {formatNumber(longPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                }
                {
                    (decoration || plated) &&
                    <ListGroupItem className="item-button" active={platedSelected || decorationSelected || sequinedSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "decorationSelected")}>
                        <div className="d-flex item-header-font">
                            <div className="item-header">{plated ? t('cart.options.withDecoAndPlated') : t('cart.options.withDeco')}</div>
                            <div className="small-price">
                                {formatNumber(decorationPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                }
                {/*
                    platedSelected &&
                    <ListGroupItem className="item-button" active={platedSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "platedSelected")}>
                        <div className="d-flex item-header-font">
                            <div className="item-header">{t('cart.options.withPlated')}</div>
                            <div className="small-price">
                                {formatNumber(platedPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                */}
                {
                    ruffles &&
                    <ListGroupItem className="item-button" active={rufflesSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "rufflesSelected")}>
                        <div className="d-flex">
                            <div className="item-header">{t('cart.options.withRuffles')}</div>
                            <div className="small-price">
                                {formatNumber(rufflesPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                }
                {
                    impregnate &&
                    <ListGroupItem className="item-button" active={impregnateSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "impregnateSelected")}>
                        <div className="d-flex">
                            <div className="item-header">{t('cart.options.withImpregnate')}</div>
                            <div className="small-price">
                                {formatNumber(impregnatePrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                }
                {
                    chiffon &&
                    <ListGroupItem className="item-button" active={chiffonSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "chiffonSelected")}>
                        <div className="d-flex">
                            <div className="item-header">{t('cart.options.withChiffon')}</div>
                            <div className="small-price">
                                {formatNumber(chiffonPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                }
                {
                    bib &&
                    <ListGroupItem className="item-button" active={bibSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "bibSelected")}>
                        <div className="d-flex">
                            <div className="item-header">{t('cart.options.withBib')}</div>
                            <div className="small-price">
                                {formatNumber(bibPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                }
                {/* DON'T USE THIS ANYMORE, IT'S NOW THE SAME AS DECO
                    (decoration || sequined) &&
                    <ListGroupItem className="item-button" active={decorationSelected || sequinedSelected}
                        onClick={() => OnAdditionalCheck(itemIndex, "sequinedSelected")}>
                        <div className="d-flex">
                            <div className="item-header">{t('cart.options.withSequins')}</div>
                            <div className="small-price">
                                {formatNumber(sequinedPrice)}
                            </div>
                        </div>
                    </ListGroupItem>
                */}
            </ListGroup>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        OnAdditionalCheck: (itemIndex, checkType) => dispatch(actions.additionalCheck(itemIndex, checkType))
    };
};

export default connect(null, mapDispatchToProps)(withTranslation()(AdditionalItem));